<template>
  <b-dropdown size="md" right text="" variant="dark" class="actionButton" v-on="$listeners">
    <template slot="button-content">
      <v-icon :name="icon" width="16" />
    </template>
    <slot></slot>
  </b-dropdown>
</template>
<script>
export default {
  extends: "b-dropdown",
  props: {
    icon: {
      type: String,
      required: false,
      default: "menu",
    },
  },
};
</script>
